import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './views/auth/Login';
import Register from './views/auth/Register';
import CHRPage from './views/gestionEstablissement/CHRPage';
import AdminPage from './views/adminEstablissement/AdminPage';
import ManageProductsPage from './views/adminEstablissement/ManageProductsPage';
import ManageSalesPage from './views/adminEstablissement/ManageSalesPage';
import EventManagement from './views/adminEstablissement/EventManagement';
import ManageContainerCardsPage from './views/hoali/ManageContainerCardsPage';
import StockManagementView from './views/hoali/StockManagementView';
import StockMugManagementView from './views/hoali/StockMugManagementView';
import DashboardView from './views/hoali/DashboardView';
import CreateDrinkForm from './views/hoali/creation_boisson/CreateDrinkForm';
import CreateContainerComponent from './components/CreateContainerComponentEtablissement';
import ManageDrinkCategories from './components/ManageDrinkCategories';
import CategoryManager from './components/CreateCategoryComponent';
import AddEntreprisePage from './views/hoali/entreprise';
import ManageProductShop from './views/hoali/ManageShopProduct';
import DisplayProducts from './components/DisplayProducts';

// Nouveaux composants pour la gestion admin
import AdaptiveHome from './views/gestionEstablissement/AdaptiveHome';
import AdminUsersManagement from './views/gestionEstablissement/AdminUsersManagement';
import AdaptiveCHRPage from './views/gestionEstablissement/AdaptiveCHRPage';
import UserEstablishmentsPage from './views/gestionEstablissement/UserEstablishmentsPage';
import AdminEstablishmentsManagement from './views/gestionEstablissement/AdminEstablishmentsManagement';
import AdminDashboard from './views/gestionEstablissement/AdminDashboard';

// >>> NOUVEAU : page d'envoi de push
import AdminPushNotifications from './views/gestionEstablissement/AdminPushNotifications';

const routes = [
  // Routes publiques (non protégées)
  { 
    path: "/", 
    element: <Login />, 
    protected: false 
  },
  { 
    path: "/register", 
    element: <Register />, 
    protected: false 
  },

  // Page d'accueil adaptée selon le rôle
  { 
    path: "/accueil", 
    element: <AdaptiveHome />, 
    protected: true, 
    requireAdmin: false 
  },

  // Gestion des établissements - Vue adaptée selon le rôle
  { 
    path: "/chr", 
    element: <AdaptiveCHRPage />, 
    protected: true, 
    requireAdmin: false 
  },

  // Routes ADMIN UNIQUEMENT - Gestion de la plateforme
  {
    path: "/admin/users",
    element: <AdminUsersManagement />,
    protected: true,
    requireAdmin: true
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
    protected: true,
    requireAdmin: true
  },
  {
    path: "/admin/dashboard2",
    element: <DashboardView />,
    protected: true,
    requireAdmin: true
  },
  {
    path: "/admin/establishments",
    element: <AdminEstablishmentsManagement />,
    protected: true,
    requireAdmin: true 
  },
  { 
    path: "/admin/manage-container-cards", 
    element: <ManageContainerCardsPage />, 
    protected: true, 
    requireAdmin: true
  },
  { 
    path: "/admin/manage-products-shop", 
    element: <ManageProductShop />, 
    protected: true, 
    requireAdmin: true
  },
  { 
    path: "/admin/gestion_stocks", 
    element: <StockManagementView />, 
    protected: true, 
    requireAdmin: true 
  },
  { 
    path: "/admin/gestion_stocks_mug", 
    element: <StockMugManagementView />, 
    protected: true, 
    requireAdmin: true
  },
  { 
    path: "/admin/create_drink", 
    element: <CreateDrinkForm />, 
    protected: true, 
    requireAdmin: true 
  },
  { 
    path: "/admin/create-categories/", 
    element: <CategoryManager />, 
    protected: true, 
    requireAdmin: true 
  },
  { 
    path: "/admin/entreprise/", 
    element: <AddEntreprisePage />, 
    protected: true, 
    requireAdmin: true 
  },

  // >>> NOUVEAU : envoi des notifications push
  { 
    path: "/admin/push", 
    element: <AdminPushNotifications />, 
    protected: true, 
    requireAdmin: true 
  },

  // Routes ÉTABLISSEMENT - Accessibles selon les droits
  { 
    path: "/admin/:id_etablissement", 
    element: <AdminPage />, 
    protected: true, 
    requireAdmin: false,
    checkEstablishmentAccess: true
  },
  { 
    path: "/admin/manage-products/:id_etablissement", 
    element: <ManageProductsPage />, 
    protected: true, 
    requireAdmin: false,
    checkEstablishmentAccess: true
  },
  { 
    path: "/admin/manage-sales/:id_etablissement", 
    element: <ManageSalesPage />, 
    protected: true, 
    requireAdmin: false,
    checkEstablishmentAccess: true
  },
  { 
    path: "/admin/manage-event/:id_etablissement", 
    element: <EventManagement />, 
    protected: true, 
    requireAdmin: false,
    checkEstablishmentAccess: true
  },
  { 
    path: "/admin/manage-container/:establishmentId", 
    element: <CreateContainerComponent />, 
    protected: true, 
    requireAdmin: false,
    checkEstablishmentAccess: true
  },
  { 
    path: "/admin/manage-shop/:establishmentId", 
    element: <DisplayProducts />, 
    protected: true, 
    requireAdmin: false,
    checkEstablishmentAccess: true
  },
  { 
    path: "/admin/users/:userId/establishments", 
    element: <UserEstablishmentsPage />, 
    protected: true, 
    requireAdmin: true 
  }
];

export default routes;